// extracted by mini-css-extract-plugin
export default {"buttons":"Buttons_buttons__YA08o"};